module.exports = __webpack_public_path__ + "img/whatsapp.2f9c6abe.png";